import React, { useState } from 'react';
import { MessageSquare, X, Send, Bot } from 'lucide-react';
export function ChatWidget() {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([{
    id: 1,
    type: 'bot',
    text: "Hi Alex! I'm your AI travel assistant. How can I help you today?"
  }]);
  const [input, setInput] = useState('');
  const handleSend = (e: React.FormEvent) => {
    e.preventDefault();
    if (!input.trim()) return;
    // Add user message
    setMessages(prev => [...prev, {
      id: Date.now(),
      type: 'user',
      text: input
    }]);
    // Simulate bot response
    setTimeout(() => {
      setMessages(prev => [...prev, {
        id: Date.now() + 1,
        type: 'bot',
        text: 'I can help you with that. Would you like me to search for available flights or check your policy limits?'
      }]);
    }, 1000);
    setInput('');
  };
  return <div className="fixed bottom-6 right-6 z-50" data-id="element-72">
      {isOpen ? <div className="flex h-[500px] w-[350px] flex-col rounded-2xl bg-white shadow-2xl ring-1 ring-slate-900/5 transition-all" data-id="element-73">
          <div className="flex items-center justify-between rounded-t-2xl bg-slate-900 px-4 py-3 text-white" data-id="element-74">
            <div className="flex items-center gap-2" data-id="element-75">
              <div className="flex h-8 w-8 items-center justify-center rounded-full bg-blue-600" data-id="element-76">
                <Bot className="h-5 w-5" data-id="element-77" />
              </div>
              <div data-id="element-78">
                <h3 className="font-medium" data-id="element-79">Travel Assistant</h3>
                <p className="text-xs text-slate-400" data-id="element-80">Online</p>
              </div>
            </div>
            <button onClick={() => setIsOpen(false)} className="rounded-full p-1 hover:bg-white/10" data-id="element-81">
              <X className="h-5 w-5" data-id="element-82" />
            </button>
          </div>

          <div className="flex-1 overflow-y-auto p-4 space-y-4 bg-slate-50" data-id="element-83">
            {messages.map(msg => <div key={msg.id} className={`flex ${msg.type === 'user' ? 'justify-end' : 'justify-start'}`} data-id="element-84">
                <div className={`max-w-[80%] rounded-2xl px-4 py-2 text-sm ${msg.type === 'user' ? 'bg-blue-600 text-white rounded-br-none' : 'bg-white text-slate-700 shadow-sm border border-slate-100 rounded-bl-none'}`} data-id="element-85">
                  {msg.text}
                </div>
              </div>)}
          </div>

          <div className="border-t border-slate-200 p-3 bg-white rounded-b-2xl" data-id="element-86">
            <div className="flex gap-2 overflow-x-auto pb-2 mb-2 scrollbar-hide" data-id="element-87">
              {['Book a flight', 'Check policy', 'Expense report'].map(action => <button key={action} className="whitespace-nowrap rounded-full border border-slate-200 bg-white px-3 py-1 text-xs font-medium text-slate-600 hover:bg-slate-50 hover:text-blue-600" onClick={() => setInput(action)} data-id="element-88">
                    {action}
                  </button>)}
            </div>
            <form onSubmit={handleSend} className="flex items-center gap-2" data-id="element-89">
              <input type="text" value={input} onChange={e => setInput(e.target.value)} placeholder="Type a message..." className="flex-1 rounded-full border border-slate-300 bg-slate-50 px-4 py-2 text-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500" data-id="element-90" />
              <button type="submit" disabled={!input.trim()} className="flex h-9 w-9 items-center justify-center rounded-full bg-blue-600 text-white transition-colors hover:bg-blue-700 disabled:opacity-50" data-id="element-91">
                <Send className="h-4 w-4" data-id="element-92" />
              </button>
            </form>
          </div>
        </div> : <button onClick={() => setIsOpen(true)} className="flex h-14 w-14 items-center justify-center rounded-full bg-blue-600 text-white shadow-lg shadow-blue-600/30 transition-transform hover:scale-105 hover:bg-blue-700" data-id="element-93">
          <MessageSquare className="h-7 w-7" data-id="element-94" />
        </button>}
    </div>;
}